





































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzIcon from 'library/v4/components/OzIcon.vue'

@Component({
  components: { OzIcon },
})
export default class SurfacePostCommentsIcon extends Vue {
  @Prop() commentIds!: [string | number]
  @Prop() colorScheme!: 'light' | 'dark'
  @Prop() disable!: boolean
  @Prop({ default: 'postView' }) usageContext!: 'postView' | 'postExpandedView'

  @namespace('browser').Getter isSmallerThanTabletPortrait!: boolean

  get isUsedInPostExpandedView(): boolean {
    return this.usageContext === 'postExpandedView'
  }

  get iconSize(): number {
    if (this.isUsedInPostExpandedView) {
      return this.isSmallerThanTabletPortrait ? 24 : 20
    }
    return 18
  }

  get commentsListLength(): number {
    return this.commentIds.length
  }

  showCommentsPanel(): void {
    if (this.disable) return
    if (this.$el.closest('.surface-post')?.classList.contains('noclick')) {
      // Prevent popping out the comment panel when the post is being dragged
      return
    }
    this.$emit('show-comments-panel')
  }
}
